// Products.js
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';
import { useNavigate } from 'react-router-dom';
import '../../css/Products.css';

function Products() {
    const [products, setProducts] = useState([]);
    const [filteredProducts, setFilteredProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("All");
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProducts = async () => {
            const productsRef = collection(db, "products");
            const snapshot = await getDocs(productsRef);
            const productList = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setProducts(productList);
            setFilteredProducts(productList);

            // Get unique categories
            const categorySet = new Set(productList.map(item => item.category));
            setCategories(["All", ...Array.from(categorySet)]);
        };

        fetchProducts();
    }, []);

    const handleCategoryChange = (category) => {
        setSelectedCategory(category);
        if (category === "All") {
            setFilteredProducts(products);
        } else {
            setFilteredProducts(products.filter(item => item.category === category));
        }
    };

    const handleShopNow = (id) => {
        // Navigate to the detail page for the product with the specified id.
        navigate(`/detail/${id}`);
    };

    return (
        <div className="products-page">
            <div className="products-header">
                <h1>All Products</h1>
                <p>Welcome to PrettyLoveColombo. We have everything you can think of. From your comfort at home to your doorstep.</p>
                {/* Category Filter Dropdown */}
                <select
                    className="category-filter"
                    value={selectedCategory}
                    onChange={(e) => handleCategoryChange(e.target.value)}
                >
                    {categories.map((cat, index) => (
                        <option key={index} value={cat}>{cat}</option>
                    ))}
                </select>
            </div>

            <div className="products-grid">
                {filteredProducts.map((item) => (
                    <div className="product-card" key={item.id}>
                        <div className="product-img-container-home">
                            <img src={item.image} alt={item.title} className="product-img-home" />
                        </div>
                        <div className="product-details">
                            <p className="product-name">{item.title}</p>
                            <div className="product-pricing">
                                {item.discount && item.discount > 0 ? (
                                    <>
                                        <span className="discounted-price">
                                            Rs.{(item.price - (item.price * item.discount / 100)).toLocaleString('en-LK')}
                                        </span>
                                        <span className="original-price">
                                            Rs.{item.price.toLocaleString('en-LK')}
                                        </span>
                                    </>
                                ) : (
                                    <span className="discounted-price">
                                        Rs.{item.price.toLocaleString('en-LK')}
                                    </span>
                                )}
                            </div>
                            <button
                                className="shop-button"
                                onClick={() => handleShopNow(item.id)}
                            >
                                Shop Now
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Products;
